export default "<div *ngIf=\"errorMessage != null\">\n  <span style=\"margin-left: 15px;\">{{errorMessage}}</span>\n</div>";